import * as React from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';

import { FormLabelWrapper, TextInput, TextArea } from '@restworld/ui-ds-base';
import { HelperTextRElement } from './form-inputs';
import { useWorkerApplicationCxt } from '../worker-application-wizard.context';

export const WizardTextInput = ({ id, type, label, errorMessage, testId, rules, ...rest }: IAppProps) => {
  const { control } = useFormContext();
  const { errorsTextMap } = useWorkerApplicationCxt();
  return (
    <FormLabelWrapper id={id} label={label}>
      {type === 'textarea' ? (
        <Controller
          name={id}
          control={control}
          rules={rules}
          render={({ field }) => (
            <TextArea
              {...field}
              id={id}
              supportText={errorMessage || errorsTextMap[id]}
              isError={!!(errorMessage || errorsTextMap[id])}
              testId={testId}
              {...rest}
            />
          )}
        />
      ) : (
        <TextInput
          id={id}
          type={type}
          control={control}
          helperText={<HelperTextRElement helperText={errorMessage || errorsTextMap[id]} />}
          color={errorMessage || errorsTextMap[id] ? 'failure' : undefined}
          testId={testId}
          rules={rules}
          {...rest}
        />
      )}
    </FormLabelWrapper>
  );
};
export default WizardTextInput;
interface IAppProps {
  id: string;
  placeholder: string;
  type: React.HTMLInputTypeAttribute;
  rules?: RegisterOptions;
  label: string;
  errorMessage?: string;
  testId?: string;
}
